import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20flowing%20ribbons%20of%20warm%20coral%20red%20and%20deep%20amber%20colors%2C%20soft%20gradients%20blending%20like%20theater%20curtains%2C%20subtle%20geometric%20particles%20floating%2C%20dark%20elegant%20atmosphere%2C%20minimalist%20and%20artistic%20composition%20with%20film%20reel%20texture%20elements&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="糖心影视 - 高清影视平台"
          className="w-full h-full object-cover"
          title="糖心影视平台高清影视在线观看"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
            <span className="text-background-50/90 text-sm">每日更新 · 即点即播 · 高清流畅</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight text-balance">
            甜蜜观影，从<span className="text-accent-400">糖心</span>开始
          </h1>
          <p className="text-background-50/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            海量高清影视资源免费在线观看，覆盖最新电影、热播电视剧全集、热门综艺、动漫番剧。
            无需下载，即点即播，流畅不卡顿，开启您的甜蜜观影之旅。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/movie"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-sm shadow-lg shadow-primary-500/25"
            >
              <span className="flex items-center justify-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line text-lg"></i>
                </div>
                立即观影
              </span>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-lg border border-background-50/20 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-8">
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">100,000+</div>
              <div className="text-xs text-background-50/50 mt-1">影视资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">500万+</div>
              <div className="text-xs text-background-50/50 mt-1">日活用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">100亿+</div>
              <div className="text-xs text-background-50/50 mt-1">累计播放</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-background-50/40">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}